export function isMilliseconds (time) {
    return (time + '').length === 13
}

export function getInitialTime (time) {
    const milliseconds = isMilliseconds(time)
        ? time
        : time * 1000

    let initialTime = new Date().getTime() - milliseconds

    return initialTime > 0
        ? Math.floor(initialTime / 1000)
        : 0
}

export function getInitialExtensionTime (extension, settings = {} ) {
    let result = 0

    const valuesToCompare = [
        extension.lastAnsweredCallEventEpoch_UTC_CLIENT,
        extension.representativeUpdated_UTC_CLIENT
    ]

    if ('resetStatusTimeOnCallUpdate' in settings && settings.resetStatusTimeOnCallUpdate) {
        valuesToCompare.push(extension.lastCallEventEpoch_UTC_CLIENT)
    }

    result = Math.max(...valuesToCompare)

    return getInitialTime(result)
}
